export interface ValidationResult {
  valid: boolean;
  message?: string;
}

export abstract class FieldValidator {
  abstract validate(value: any, field?: any): ValidationResult;
}
